// React libs
import PropTypes from 'prop-types';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
// Components
import ConfirmModale from '../../../../../Core/Components/UiKit/Modales/ConfirmModale/ConfirmModale';
// Types
import * as Types from './SwitchProjectConfirmModal.type';

const SwitchProjectConfirmModal: FC<Types.IProps> = ({ handleClose, isOpened }) => {
  const { t } = useTranslation(['common'])
  return <div data-testid='switch-project-confirm-modal'>
    <ConfirmModale
      handleClose={handleClose}
      id='switch-project-confirm-modal'
      message={t('common:modales.confirm.switchProject')}
      isOpened={isOpened}
    />
  </div>

}

SwitchProjectConfirmModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isOpened: PropTypes.bool.isRequired
}

export default SwitchProjectConfirmModal